import { css } from '@emotion/css';

import { Colors, LARGE_DEVICE_MQ, Spacing } from 'apps/shared/scripts/styles/constants';

export const dismissButtonClassName = css({
  position: 'absolute',
  top: Spacing.XL,
  right: Spacing.XL,
  zIndex: 999,
  [LARGE_DEVICE_MQ]: {
    display: 'none',
  }
});

export const buttonClassName = css({
  background: 'none',
  border: 'none',
  borderRadius: '50%',
  padding: 0,
  position: 'relative',
  i: {
    height: 24,
    marginRight: 0,
    width: 24,
    svg: {
      fill: Colors.Primary,
    },
  },
});
